const contactus = {
    TICKET: "پشتیبانی",
    DESCRIPTION: "در صورت وجود مشکل یا هر گونه سؤال، از طریق ارسال «پیام» در تلگرام یا واتس اپ با ما در ارتباط باشید",
    TELEGRAM: "negahgroup_ir",
    WHATSAPP: "۲۸۱۸ ۶۲۴ ۰۹۳۰",
    NO_CALL: 'توجه کنید به «تماس‌» جهت پشتیبانی، ترتیب اثر داده نخواهد شد',
}

export default contactus